import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./errorView.module.css";
import backgroundUrl from "../../assets/images/errorViewBackground-1400x600.webp";
import mobileBackgroundUrl from "../../assets/images/errorViewBackground-380x600.webp";

const DEFAULT_HEADER = "Oops!";
const DEFAULT_MESSAGE = "Looks like something went wrong. Sorry about that.";
const DEFAULT_PROMPT = "Take me home";

const ErrorView = (props) => {
  const navigate = useNavigate();

  const handleGoHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const {
    header = <span>{DEFAULT_HEADER}</span>,
    message = <span>{DEFAULT_MESSAGE}</span>,
    buttonPrompt = <span>{DEFAULT_PROMPT}</span>,
    onClick = handleGoHome,
  } = props;

  const handleClick = useCallback(() => {
    onClick && onClick();
  }, [onClick]);

  const style = {
    "--backroundImageUrl": `url("${backgroundUrl}")`,
    "--mobileBackgroundImageUrl": `url("${mobileBackgroundUrl}")`,
  };

  return (
    <div className={classes.root} style={style}>
      <div className={classes.content}>
        <p className={classes.header}>{header}</p>
        <p className={classes.message}>{message}</p>
        <div className={classes.actionsContainer}>
          <button priority="high" type="button" onClick={handleClick}>
            {buttonPrompt}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorView;
